export default __webpack_public_path__ + "static/media/bg-mobile.329922d1.jpg";